/* eslint-disable react/forbid-prop-types */
import {
  DialogContent,
  Dialog,
  Button,
  DialogTitle,
  Grid,
  DialogActions,
  TextField,
  Typography,
} from "@material-ui/core";
import clsx from "clsx";
import React, { Component } from 'react';
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { doFetch } from '../../../services/fetch/fetch.actions';
import { postModifyCommittee } from '../../../services/admin/committee-service';

class ElementsDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      elementsID: props.committee.elements_id || "",
      errorMessage: "",
    };
  }


  checkIDValidity(id) {
    if (id === "") {
      return false;
    }

    return true;
  }

  handleSave(id, elementsID) {
    const { dispatch, closeDialog } = this.props;

    const c = {
      elements_id: elementsID,
    }

    dispatch(doFetch(
      'COMMITTEE_UPDATE',
      postModifyCommittee(id, c)
        .then((res) => {
          if (!res.ok) {
            res.json().then((body) => {
              this.setState({ errorMessage: body.error || res.statusText });
            });
            return res.json();
          }

          this.setState({ errorMessage: "" });
          closeDialog();
          return res.json();
        }),
    ));
  }
  
  render() {
    const { classes, committee, open, closeDialog } = this.props;
    const { elementsID, errorMessage } = this.state;

    const validCommittee = this.checkIDValidity(elementsID);

    return (
      <Dialog open={open} onClose={() => closeDialog()}>
        <DialogTitle>Endre elements ID for {`'${committee.display}'`}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                // eslint-disable-next-line no-use-before-define
                className={clsx(classes.role, classes.label)}
                variant="outlined"
                label="Elements ID"
                onChange={(event) => {
                  this.setState({ elementsID: event.target.value });
                }}
                value={elementsID}
              />
            </Grid>
            { errorMessage !== "" && (
              <Grid item xs={12}>
                <Typography variant="body2" className={classes.alert}>
                  {errorMessage}
                </Typography>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeDialog()}>Avbryt</Button>
          <Button disabled={!validCommittee} onClick={() => this.handleSave(committee.id, elementsID)}>Lagre</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ElementsDialog.propTypes = {
  dispatch: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  committee: PropTypes.object,
  open: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func,
};

ElementsDialog.defaultProps = {
  closeDialog: () => {},
  committee: {},
};

const styles = (theme) => ({
  size: {
    minHeight: "12rem",
    [theme.breakpoints.up("sm")]: {
      minWidth: "25rem",
    },
    [theme.breakpoints.down("xs")]: {
      minWidth: "17rem",
    },
  },
  dialogContent: {
    overflow: "visible",
  },
  dialog: {
    overflow: "visible",
  },
  secondary: {
    color: "rgba(0, 0, 0, 0.54)",
    paddingBottom: "1rem",
  },
  primary: {
    paddingTop: "1.5rem",
  },
  role: {
    marginTop: "1.5rem",
    width: "100%",
  },
  select: {
    paddingLeft: "2px",
  },
  label: {
    zIndex: 0,
  },
  datepicker: {
    marginTop: "1.5rem",
    width: "12rem",
  },
  mr: {
    marginRight: "1.5rem",
  },
  alert: {
    backgroundColor: "rgb(255, 244, 229)",
    color: "rgb(102, 60, 0)",
    padding: "1rem",
    maxWidth: "60rem",
    marginTop: "1rem",
    borderRadius: "4px",
    display: "flex",
  },
});

export default connect(null)(withStyles(styles, { withTheme: true })(ElementsDialog));